import type { TFunction } from 'i18next'

import type { IFundSummaryItem } from 'src/components/molecules/fund-summary'

import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import type { IFundUpdateStatsResponseDTO } from '../contracts/fund-updates'

export interface IMapFundUpdateStatsReturn {
  summaryAsOf: string
  fundSummaryItems: IFundSummaryItem[]
}

const formatSummaryAsOf = (asOfDate: string | null): string => {
  return DateAdapter.formatReleaseDate(asOfDate ?? new Date().toDateString())
}

const toDisplayValue = (value: string | null): string => value ?? '-'

export const mapFundUpdateStats = (
  dto: IFundUpdateStatsResponseDTO,
  t: TFunction,
): IMapFundUpdateStatsReturn => {
  const fundName = dto.fund_name ?? ''
  const percentage = toDisplayValue(dto.unfunded_commitment_percentage)

  return {
    summaryAsOf: formatSummaryAsOf(dto.as_of_date),
    fundSummaryItems: [
      {
        label: t('fundUpdates.summary.totalCommitment'),
        value: toDisplayValue(dto.total_commitment),
        description: fundName,
      },
      {
        label: t('fundUpdates.summary.unfundedCommitment'),
        value: toDisplayValue(dto.unfunded_commitment),
        description: t('fundUpdates.summary.unfundedCommitmentDescription', {
          percentage,
        }),
      },
      {
        label: t('fundUpdates.summary.contributions'),
        value: toDisplayValue(dto.contributions),
        description: toDisplayValue(dto.contributions_percentage),
      },
      {
        label: t('fundUpdates.summary.distributions'),
        value: toDisplayValue(dto.distributions),
        description:
          dto.distributions != null
            ? t('fundUpdates.summary.distributionsDescription')
            : '',
      },
    ],
  }
}
